module.exports = __webpack_public_path__ + "static/img/big-gem@3x.62344894.png";